import React from 'react';
import PageBase from '../components/PageBase';
import Paper from 'material-ui/Paper';
import { Table, TableHeader, TableBody, TableRow, TableRowColumn, TableHeaderColumn} from 'material-ui/Table';
import {Helmet} from "react-helmet";

const Sailkapenak = () => {
  return (
    <PageBase title="Sailkapenak"
              navigation="Oñatiko Duatloi Txikia / Sailkapenak">
        
    <Helmet>
        <title>Oñatiko Dutloi Txikia Sailkapenak</title>
        <meta name="description" content="Oñatiko duatloi txikiko sailkapenak, bideo eta argazkiak" />
        <meta property="og:title" content="Oñatiko Dutloi Txikio Sailkapenak" />
        <meta property="og:description" content="Oñatiko duatloi txikirako sailkapenak, bideo eta argazkiak" />
        <meta property="og:url" content="http://duatloitxikia.oinatikoduatloia.com/sailkapenak" />
        <meta property="og:image" content="http://www.txantxiku.net/duatlon_onati/duatloi_txikia_2018/slides/IMG_2085.JPG" />
    </Helmet>

    <Paper style={{ padding: "30px", marginTop: 20, marginBottom: 20 }}>Sailkapenak soilik infantil mailan</Paper>
      

    <h2>Oñatiko I. Duatloi Txikia. Infantil maila</h2>
    <Table
        selectable={false}>
        <TableHeader
            displaySelectAll={false}>
            <TableRow
                selectable={false}>
                <TableHeaderColumn>Postua</TableHeaderColumn>
                <TableHeaderColumn>Izena</TableHeaderColumn>
                <TableHeaderColumn>Denbora</TableHeaderColumn>
            </TableRow>
        </TableHeader>
        
        <TableBody
            displayRowCheckbox={false}
            showRowHover={true}>
            <TableRow>
                <TableRowColumn>1</TableRowColumn>
                <TableRowColumn>Asier Iguiñiz Porres</TableRowColumn>
                <TableRowColumn>25:48</TableRowColumn>
            </TableRow>

            <TableRow>
                <TableRowColumn>2</TableRowColumn>
                <TableRowColumn>Aitor Pereda Ramos</TableRowColumn>
                <TableRowColumn>30:58</TableRowColumn>
            </TableRow>

            <TableRow>
                <TableRowColumn>3</TableRowColumn>
                <TableRowColumn>Peio Ferreiro Fernandez</TableRowColumn>
                <TableRowColumn>32:26</TableRowColumn>
            </TableRow>
        </TableBody>
    </Table>

    <Paper style={{padding: 10}}>

        <p>2018 Argazkiak: <a href="http://www.txantxiku.net/duatlon_onati/duatloi_txikia_2018/index.html" target="_blank">Jesus Cantero</a></p>
        <p>2018 Bideoak: <a href="https://goiena.eus/oinati/1521295084946-160-neska-mutiko-onatiko-lehen-duatloi-txikian" target="_blank">Goiena</a> | <a href="https://goiena.eus/oinati/1521536444193-harmailatik-kronika-onatiko-lehen-duatloi-txikia" target="_blank">Goienako Harmailatik elkarrizketekin</a> | <a href="https://www.youtube.com/watch?v=Z9g7nrtKVUg" target="_blank">Andoni</a> </p>
    </Paper>

    </PageBase>
  );
};

export default Sailkapenak;



/** WEBPACK FOOTER **
 ** ./src/containers/Sailkapenak.js
 **/